import { components } from "react-select";

const ReactSelectItem = (props) => {
  return (
    <components.Option {...props}>
      <div className="d-flex align-items-start justify-content-between">
        <div className="left">
          <p className="m-0" style={{ fontSize: 14 }}>
            {props.data.label}
          </p>
        </div>
      </div>
    </components.Option>
  )
}

export default ReactSelectItem;